<template>
  <div>
    <header class="header">
      <Search />
      <div class="header-main">
        <img src="@/assets/img/gh.png" alt="" class="gh" />
        <div class="header-title">安徽人大</div>
      </div>
    </header>

    <div class="content">
      <!-- 左边菜单 -->
      <div class="content-left">
        <div class="left-menuTitle">{{ pageTitle }}</div>
        <div class="left-menu">
          <div v-for="item in menuList" :key="item.id" class="menu-block">
            <!-- 一级目录 -->
            <div
              :class="['item', colId == item.id && 'menuActive']"
              @click="changeMenu(item)"
            >
              <div style="display: flex; align-items: center">
                <span>
                  <img
                    src="@/assets/img/menu-icon.png"
                    alt=""
                    style="width: 12px; margin-right: 10px"
                  />
                </span>
                <span>{{ item.name }}</span>
              </div>
            </div>

            <!-- 二级目录 -->
            <div v-if="item.children && item.children.length" class="submenu">
              <div
                v-for="child in item.children"
                :key="child.name"
                :class="['subItem', colId == child.id && 'menuActive']"
                @click="changeMenu(child)"
              >
                <span>{{ child.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="content-main">
          <!-- 头部导航 -->
          <div class="content-menu">
            <div
              v-for="(item, index) in navList"
              :key="item.name"
              :class="['item', columnKeywords == item.code && 'navActive']"
              @click="changeNav(item, index)"
            >
              <div class="item-content">
                <img :src="item.icon" alt="" />
                <p>{{ item.name }}</p>
              </div>
            </div>
          </div>
          <!-- <new-list :menu-active="menuActive" :menu-list="menuList" /> -->
          <!-- 内容 -->
          <!-- 列表内容 -->
          <div class="list-container" v-if="!showDetail">
            <div class="title">{{ listTitle }}</div>
            <div class="list">
                <div class="line" v-for="item in newsList" :key="item.id" @click="goDetail(item)">
                    <div class="desc">{{ item.masTitle }}</div>
                    <div class="time">{{ item.dpubDate }}</div>
                </div>
            </div>
            <div class="page">
              <a-pagination v-if="total > 10" show-quick-jumper :default-current="1" :total="total" :defaultPageSize="page.pageSize" @change="changePage" />
            </div>
          </div>
          <new-detail v-if="showDetail" @back="showDetail = false" :title="listTitle" :id="detailId" />
        </div>
      </div>
    </div>

    <Footer :showSearch="false" />
  </div>
</template>

<script>
import api from "@/utils/api.js";
import Search from "@/components/search/search.vue";
import Footer from "@/components/footer/footer.vue";
import { NavList } from "@/utils/contans.js";
import newList from "./list.vue";
import newDetail from "@/components/newDetail/index.vue";
export default {
  name: "PageList",
  components: { Search, Footer, newList, newDetail },
  data() {
    return {
      menuList: [],
      navList: NavList,
      menuActive: "",
      navActive: 0,
      webSiteId: window.$configApi.webSiteId,
      colId: '',
      detailId: this.$route.query.detailId || '',
      columnKeywords: this.$route.query.code || 'wxzx',
      newsList: [],
      total: 0,
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      listTitle: '',
      isFirstMenu: true,
      showDetail: false
    };
  },
  watch: {
    // 监听路由变化, 列表页根据路由判断选中，详情页根据标题判断选中
    $route(to) {
      console.log('watch===route,监听路由变化')
      this.initMenu()
      
      // this.updateActive(to.path, to.query);
    },
    colId(val) {
      if(val) {
      console.log(val,'watch===colId')
        this.showDetail = false
        this.getList()
        this.getMenuByColId()
      }
    },
  },
  computed: {
    pageTitle() {
      return NavList.find(item => item.code == this.columnKeywords).name
    }
  },
  created() {
    this.initMenu()
  },
  methods: {
    // 页面初始化时选中正确的菜单
    async initMenu() {
      this.detailId = this.$route.query.detailId
      this.colId = this.$route.query.colId
      this.columnKeywords = this.$route.query.code
      await this.getColumnTree()
      if(this.$route.query.detailId) {
        console.log('watch===showDetail')
        this.showDetail = true
      }
    },
    // 获取左侧菜单
    async getColumnTree() {
      const params = {
        webSiteId: window.$configApi.webSiteId,
        columnKeywords: this.columnKeywords
      }
      const {code, data} = await api.getColumnTree(params)
      if(code == '00000') {
        this.menuList = data
        if(!this.$route.query.colId) {
          this.colId = data?.length ? data[0].id : ''
        }
        // this.getList()
        this.getMenuByColId()
      }
    },
    // 根据菜单colId获取列表list
    async getList() {
      const params = {
        colId: this.colId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        webSiteId: this.webSiteId,
      }
      const apiFn = this.isFirstMenu ? api.getInfoList2 : api.getInfoList;
      const res = await apiFn(params);
      this.newsList = res.data.records;
      this.total = res.data.total;
    },
    changeMenu(item) {
      if(this.colId == item.id) return
      this.colId = item.id
      this.isFirstMenu = item.parentId == '-1' ? true : false
      this.resetList()
    },
    // 遍历menuList，根据colId匹配菜单
    getMenuByColId() {
      this.menuList.forEach(item => {
        if(item.id == this.colId) {
          this.listTitle = item.name
        } else if(item.children && item.children.length) {
          item.children.forEach(child => {
            if(child.id == this.colId) {
              this.listTitle = child.name
            }
          })
        }
      })
    },
   
    changeNav(item, index) {
      // console.log(item, index,'changeNav')
      // console.log(item.code, this.columnKeywords,'changeNav')
      if(this.columnKeywords == item.code) return
      this.resetList()
      this.isFirstMenu = true
      const router = {
        path: item.path,
        query: {}
      }
      if(item.code) router.query.code = item.code
      this.$router.push(router);
      // if (this.$route.path !== item.path) {
      //   this.navActive = index;
      //   const router = {
      //     path: item.path,
      //     query: {}
      //   }
      //   if(item.code) router.query.code = item.code
      //   this.$router.push(router);
      // }
    },
    resetList() {
      this.showDetail = false
      this.newsList = []
      this.total = 0
      this.listTitle = ''
      this.page.pageNum = 1
    },
    changePage(page) {
      console.log(page,'changePage')
      this.page.pageNum = page;
      this.getList()
    },
    goDetail(item) {
        this.showDetail = true;
        this.detailId = item.id;
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 500px;
  opacity: 1;

  background: url("@/assets/img/bg2.png") no-repeat;
  background-size: cover;
  position: relative;
  .header-main {
    display: flex;
    align-items: center;
    padding-left: 120px;
    height: 160px;
    .gh {
      width: 74px;
      height: 80px;
    }
    .header-title {
      font-size: 48px;
      font-weight: 900;
      letter-spacing: 0.1em;
      color: #ffffff;
      padding-left: 60px;
    }
  }
}

.content {
  display: flex;
  padding: 80px 160px;
  gap: 50px;
  background: url("@/assets/img/listBg.png") no-repeat;
  background-size: cover;
  .content-left {
    .left-menuTitle {
      width: 220px;
      height: 127px;
      opacity: 0.8;
      margin-top: -207px;
      text-align: center;
      line-height: 127px;
      font-size: 30px;
      font-weight: bold;
      color: #ffffff;

      background: linear-gradient(
          180deg,
          rgba(30, 101, 243, 0.87) 0%,
          #4ac7f9 100%
        ),
        linear-gradient(180deg, #8ccfff 5%, rgba(65, 150, 255, 0.44) 100%),
        #d8d8d8;
    }
    .menuActive {
      color: #fff;
      position: relative;
      z-index: 2;
      font-weight: bold;
      // &::after {
      //   content: "";
      //   position: absolute;
      //   left: -22px;
      //   top: 0;
      //   width: 140%;
      //   height: 120%;
      //   background: url("@/assets/img/navActive.png") no-repeat;
      //   z-index: -1;
      // }
      .menuAc {
        position: absolute;
        left: 0;
        position: absolute;
        left: -42px;
        top: 0;
        z-index: 0;
        width: 140%;
        height: 80px;
      }
    }
    .left-menu {
      width: 220px;
      height: calc(100% + 80px);
      opacity: 1;
      padding: 10px;

      background: #ffffff;
      font-size: 20px;
      font-weight: bold;
      line-height: 22px;
      color: #1f2d3d;

      .item {
        // background-color: red;
        text-align: center;
        padding: 20px;
        cursor: pointer;
      }
      .submenu {
        padding-left: 20px;
        .subItem {
          padding: 10px;
          font-size: 16px;
          font-weight: normal;
          cursor: pointer;
          text-align: center;
        }
      }
      .menuActive {
        color: #fff;
        background: linear-gradient(
            180deg,
            rgba(30, 101, 243, 0.87) 26%,
            #0fa4df 100%
          ),
          #074899;
        border-radius: 4px;
      }
    }
  }

  .content-right {
    width: 83%;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 0;
      right: 0;
      height: 112px;
      background: url("@/assets/img/navTop.png") no-repeat top center;
      background-size: 100% 100%;
      z-index: 0;
    }
  }
  .content-main {
    position: relative;
    z-index: 2;
    width: calc(100% - 105px);
    margin: 0 auto;
    min-height: 60vh;
    // height: 100%;
    background-color: #fff;
    margin-top: -200px;
  }
  .content-menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    opacity: 1;
    padding: 0 40px;

    background: linear-gradient(
        180deg,
        rgba(30, 101, 243, 0.87) 26%,
        #0fa4df 100%
      ),
      #074899;
    .item {
      cursor: pointer;
      font-size: 28px;
      line-height: 28px;
      color: #ffffff;
    }
    .navActive {
      font-weight: bold;
    }
    .item-content {
      display: flex;
      align-items: center;
      img {
        width: 30px;
        margin-right: 10px;
      }
    }
  }
}

.bread {
  height: 54px;
  display: flex;
  align-items: center;
  padding-left: 32px;
  opacity: 1;

  background: linear-gradient(
    180deg,
    rgba(204, 227, 255, 0) 0%,
    rgba(204, 227, 255, 0.27) 100%
  );
}
.list-container {
  padding: 32px;
  .title {
    margin-bottom: 12px;
    font-size: 20px;
    font-weight: bold;
    color: #01206c;
  }
  .line {
    height: 70px;
    line-height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e2e8f0;
    cursor: pointer;
    .desc {
        position: relative;
        padding-left: 20px;
        font-size: 18px;
        font-weight: normal;
        color: #1f2d3d;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-grow: 1;
        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 1px;
            transform: translateY(-50%);
            width: 4px;
            height: 4px;
            background: #1f2d3d;
        }
    }
    .time {
        font-size: 16px;
        margin-left: 20px;
        flex-shrink: 0;
    }
  }
  .page {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 40px 0;
  }
}

</style>
